// A one-shot "focus the upload drop zone" flag, handed off from
// pages/LandingPage.jsx's "Upload BOQ or PDF" hero button to whichever
// screen renders components/RequestLinesForm.jsx next (pages/GuestPage.jsx's
// 'form' step, or pages/RequestFormPage.jsx) — same shape and reasoning as
// utils/pendingLine.js's own "Request price" hand-off, kept as a separate
// key rather than folded into that one: a pending line is DATA that belongs
// in the eventual lines array, this is a UI-only instruction ("scroll to and
// focus this element") that never touches form state at all.
//
// Plain localStorage, not part of either flow's own usePersistedState draft,
// for the identical reason pendingLine.js gives: the button is clicked from
// the landing page, before either flow's component has mounted.

const PENDING_UPLOAD_FOCUS_KEY = 'sneethel.portal.pendingUploadFocus';

export function setPendingUploadFocus() {
  try {
    window.localStorage.setItem(PENDING_UPLOAD_FOCUS_KEY, '1');
  } catch {
    // Non-fatal — the destination screen just won't auto-focus the drop
    // zone; the buyer can still click it themselves.
  }
}

// Reads AND clears in one call — consumed exactly once, by whichever
// screen's mount effect gets there first (mirrors consumePendingLine).
export function consumePendingUploadFocus() {
  try {
    const raw = window.localStorage.getItem(PENDING_UPLOAD_FOCUS_KEY);
    if (!raw) return false;
    window.localStorage.removeItem(PENDING_UPLOAD_FOCUS_KEY);
    return true;
  } catch {
    return false;
  }
}
